var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{},[_c('p',{staticClass:"h3"},[_vm._t("title")],2),_vm._t("p m-0"),_c('div',{staticClass:"d-flex align-items-center"},[_c('div',[_c('ul',{staticClass:"nav"},[_vm._t("nav")],2)]),_c('div',{staticClass:"ml-auto mb-4"},[_vm._t("buttons")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }